import { TParametersComparisonData } from '../../../../types/models/DataAnalysis'

export type TParametersComparisonChartRow = {
  code: string
  value: number
  std: number
}

export const toParametersComparisonData = (
  arr: unknown
): TParametersComparisonChartRow[] => {
  const list: TParametersComparisonData[] = Array.isArray(arr)
    ? (arr as TParametersComparisonData[])
    : []
  return list
    .filter((p) => p && p.value !== null)
    .map((p) => ({
      code: p.wheat_code,
      value: Number(p.value),
      std: p.std_dev ? Number(p.std_dev) : 0,
    }))
}
